'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LegendStyle = require('./LegendStyle.scss');

var _LegendStyle2 = _interopRequireDefault(_LegendStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legend = (_dec = (0, _reactCssModules2.default)(_LegendStyle2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Legend, _React$Component);

  function Legend() {
    (0, _classCallCheck3.default)(this, Legend);
    return (0, _possibleConstructorReturn3.default)(this, (Legend.__proto__ || (0, _getPrototypeOf2.default)(Legend)).apply(this, arguments));
  }

  (0, _createClass3.default)(Legend, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          smallMobile = _props.smallMobile,
          legendProps = (0, _objectWithoutProperties3.default)(_props, ['smallMobile']);

      delete legendProps.styles;
      var style = smallMobile ? 'a-legend a-legend--small-mobile' : 'a-legend';

      return _react2.default.createElement('legend', (0, _extends3.default)({ styleName: style }, legendProps));
    }
  }]);
  return Legend;
}(_react2.default.Component), _class2.propTypes = {
  smallMobile: _react.PropTypes.bool
}, _class2.defaultProps = {
  smallMobile: false
}, _temp)) || _class);
exports.default = Legend;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/Legend.js
// module id = 2470
// module chunks = 0